<template>
  <f7-page @page:beforein="beforein">
    <navbar :text="`${$t('LeftPanel_title_ParcelSystem')} > ${actualUser.name} >  ${actualLocation.name} > ${currentParcel.name} > ${$t('sectors')}`" />
    <RegisterSectorStep1
      :ground-textures-availables="groundTexturesAvailables"
      :irrigation-types-availables="irrigationTypesAvailables"
      :current-sector="currentSector"
    />
    <f7-row>
      <f7-col>
        <f7-button
          class="dx-btn-cancel margin-right"
          raised
          type="default"
          text-color="grey"
          styling-mode="outlined"
          name="ButtonCancel"
          @click="goToBack()"
        >
          {{ $t('Button_go_to_back') }}
        </f7-button>
      </f7-col>
      <f7-col>
        <f7-button
          class="dx-btn-success"
          raised
          type="success"
          styling-mode="contained"
          @click="goToStep2"
        >
          {{ $t("next") }}
        </f7-button>
      </f7-col>
    </f7-row>
    <AutoRegisterSectorCoordinatesPopup />
    <PopupRegisterSectorStep2 />
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import RegisterSectorStep1 from '../../components/sector/registerSectorStep1/index.vue';
import navbar from '../../components/NavBar.vue';
import AutoRegisterSectorCoordinatesPopup from './autoRegisterSectorCoordinatesPopup/index.vue';
import PopupRegisterSectorStep2 from '../../components/sector/popupRegisterSectorStep2/index.vue';

export default {
  name: 'RegisterSectorStep1Page',
  components: {
    RegisterSectorStep1,
    navbar,
    AutoRegisterSectorCoordinatesPopup,
    PopupRegisterSectorStep2,
  },
  data() {
    return {
      groundTexturesAvailables: [],
      irrigationTypesAvailables: [],
    };
  },
  computed: {
    ...mapState('Sector', ['currentSector', 'currentKeyValues']),
    ...mapState('Parcel', ['currentParcel']),
    ...mapState('Explotaciones', ['actualLocation', 'actualUser']),
  },
  methods: {
    async beforein() {
      this.$f7.preloader.show();
      try {
        await this.fetchKeyValuesByFamily('GROUND_TEXTURE');
        this.groundTexturesAvailables = this.currentKeyValues;
        await this.fetchKeyValuesByFamily('IRRIGATION_TYPE');
        this.irrigationTypesAvailables = this.currentKeyValues;
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(`${error}`),
            width: 550,
          },
          'error',
          3000,
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    goToStep2() {
      if (this.validationForm()) {
        // Esto es para el cuadro de diálogo que crea un sector que ocupa toda la parcela.
        if (this.currentParcel.children.length === 0 && !this.currentSector.id) {
          this.setShowAutoSector(true);
        } else {
          this.$f7.views.main.router.navigate('/registerSectorStep2Page/', { reloadCurrent: true });
        }
      }
    },
    goToBack() {
      if (typeof this.currentSector.id === 'undefined') {
        this.$f7.views.main.router.navigate('/viewParcel/', { reloadCurrent: true });
      } else {
        this.$f7.views.main.router.navigate('/viewSector/', { reloadCurrent: true });
      }
    },
    validationForm() {
      let validationMainForm = false;
      let validationIrrigationForm = false;
      if (this.currentSector.sectorName === '') {
        this.$notifyDX(
          {
            message: this.$t('sector.register.required_name'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.currentSector.groundTexture === '' || this.currentSector.groundTexture === null) {
        this.$notifyDX(
          {
            message: this.$t('sector.register.required_groundTexture'),
            width: 550,
          },
          'info',
          3000,
        );
      } else if (this.currentSector.irrigationType === '' || this.currentSector.irrigationType === null) {
        this.$notifyDX(
          {
            message: this.$t('sector.register.required_irrigationType'),
            width: 550,
          },
          'info',
          3000,
        );
      } else {
        validationMainForm = true;
      }

      if (this.currentSector.irrigationType !== ''
      && this.currentSector.irrigationType !== null) {
        switch (this.currentSector.irrigationType) {
          case 'GOTEO':
            validationIrrigationForm = this.validationIrrigationTypeGoteo();
            break;
          case 'ASPERSIÓN':
            validationIrrigationForm = this.validationIrrigationTypeAspersion();
            break;
          case 'INUNDACIÓN':
            validationIrrigationForm = this.validationIrrigationTypeInundacion();
            break;
          default:
            validationIrrigationForm = true;
            break;
        }
      }
      return validationMainForm && validationIrrigationForm;
    },
    validationIrrigationTypeGoteo() {
      if (this.currentSector.flow === 0 || this.currentSector.flow === null) {
        this.$notifyDX(
          {
            message: this.$t('sector.register.required_flowPerPlant'),
            width: 550,
          },
          'info',
          3000,
        );
        return false;
      }
      if (this.currentSector.dripperPerPlant === 0 || this.currentSector.dripperPerPlant === null) {
        this.$notifyDX(
          {
            message: this.$t('sector.register.required_dripperPerPlant'),
            width: 550,
          },
          'info',
          3000,
        );
        return false;
      }
      return true;
    },
    validationIrrigationTypeAspersion() {
      if (this.currentSector.sprinklersNumber === 0 || this.currentSector.sprinklersNumber === null) {
        this.$notifyDX(
          {
            message: this.$t('sector.register.required_sprinklersNumber'),
            width: 550,
          },
          'info',
          3000,
        );
        return false;
      }
      if (this.currentSector.flow === 0 || this.currentSector.flow === null) {
        this.$notifyDX(
          {
            message: this.$t('sector.register.required_flowPerPlant'),
            width: 550,
          },
          'info',
          3000,
        );
        return false;
      }
      if (this.currentSector.transformedArea === 0 || this.currentSector.transformedArea === null) {
        this.$notifyDX(
          {
            message: this.$t('sector.register.required_transformedArea'),
            width: 550,
          },
          'info',
          3000,
        );
        return false;
      }
      return true;
    },
    validationIrrigationTypeInundacion() {
      if (this.currentSector.flow === 0 || this.currentSector.flow === null) {
        this.$notifyDX(
          {
            message: this.$t('sector.register.required_flowPerPlant'),
            width: 550,
          },
          'info',
          3000,
        );
        return false;
      }
      return true;
    },
    ...mapActions('Sector', ['fetchKeyValuesByFamily']),
    ...mapActions('Sector', ['setShowAutoSector']),
  },
};
</script>

<style scoped>
.dx-btn-cancel.margin-right {
width: 15%;
margin-left: 2%;
}
.dx-btn-success {
width: 30%;
margin-left: 68%;

}
</style>
